import { isBuildIn } from '../build-in';
import { appI18n } from '../i18n';

export const getCurrencySymbols = (type?: number | string): string => {
  if (type === undefined && isBuildIn()) {
    type = 2;
  }
  switch (type) {
    case 0:
      return appI18n.t('pkg_common.currency.points') as string;
    case 1:
      return '¥';
    case 2:
      return '$';
    case 3:
      return '€';
    default:
      return '¥';
  }
};
